import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'board',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'tab',
    path: 'selected.board_id',
    viewPath: props.viewPath,
  })

  let value = useDataValue({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let { stages, ...rest } = value || {}
    submit({
      type: id === 'new' ? 'create' : 'update',
      value: {
        ...rest,
        stages: stages.map(({ id, text, order, done }) => ({
          id,
          text,
          order,
          done,
        })),
      },
    })
  }
}

export function isDisabled(name, locations, stages, hasChanges) {
  if (stages.filter(stage => !stage.text).length > 0) return true
  if (!name || name === 'New Board') return true
  if (!locations?.length) return true

  return !hasChanges
}
